export interface CopyrightProps {}

export const useCopyright = (props: CopyrightProps) => {
  const thisYear = new Date().getFullYear()

  return {
    ...props,
    thisYear,
  }
}
